import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var StyledPlaceholder = styled.div.withConfig({
  displayName: "DateInputPlaceholder__StyledPlaceholder",
  componentId: "sc-9fdqo8-0"
})(["&&{position:absolute;top:0;bottom:0;left:0;right:0;background:white;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}"]);
var DateInputPlaceholder = function DateInputPlaceholder(_ref) {
  var placeholder = _ref.placeholder;
  if (!placeholder) return null;
  return /*#__PURE__*/jsx(StyledPlaceholder, {
    children: placeholder
  });
};
DateInputPlaceholder.displayName = "DateInputPlaceholder";

export { DateInputPlaceholder };
